// Toast copy for a HITL answer that the server wouldn't accept.
//
// A 409 means the server refused the resume outright, and the two ways that
// happens need opposite advice: a run already in flight resolves on its own,
// while an answer that no longer matches the conversation's pending calls will
// be refused identically no matter how many times it is retried. Both carry
// user-facing wording in `detail`, so the server's own phrasing wins; anything
// else (5xx, a dropped connection) is transient, and retrying is the advice.
const TRANSIENT = "Couldn't send your answer. Try again in a moment.";

// AG-UI's HTTP transport rejects with a plain Error carrying the status and the
// decoded body, so neither is reachable through a typed error class.
type HttpError = { status: number; payload?: unknown };

function asHttpError(error: unknown): HttpError | null {
  if (typeof error !== "object" || error === null) return null;
  const { status } = error as { status?: unknown };
  return typeof status === "number" ? (error as HttpError) : null;
}

export function answerErrorMessage(error: unknown): string {
  const httpError = asHttpError(error);
  if (httpError?.status !== 409) return TRANSIENT;
  const { detail } = (httpError.payload ?? {}) as { detail?: unknown };
  return typeof detail === "string" && detail.trim() ? detail : TRANSIENT;
}
